module.exports = __webpack_public_path__ + "assets/img/9_433_big.94be86f6.jpg";